import { ISidenavSvgIcon } from '@cde-fe-app/app/shared/components/cde-sidenav/models/sidenav.model';
import { CustomDimension, ITrackingEventNewPayload } from '@cde-fe-app/app/shared/models/event-tracking.model';
import { PLATTFORM_ADVANCED_PERMISSION, PLATTFORM_BASE_PERMISSION } from '@cde-fe-app/app/shared/utils/permission';
import { environment } from '@cde-fe-app/environments/environment';

export interface IAppLauncherFastAccessDescription {
  icon?: ISidenavSvgIcon;
  iconImg?: string;
  name: string;
  link: string;
  testId: string;
  trackEventNew?: ITrackingEventNewPayload;
  appendOrgId?: boolean;
  outsideLink?: boolean;
  newTabLink?: boolean;
}

export interface IAppLauncherAppDescription extends IAppLauncherFastAccessDescription {
  description: string;
  permission: string[];
  testId: string;
  appendOrgId?: boolean;
  appLauncerFastAccess?: IAppLauncherFastAccessDescription[];
  target?: string;
}

const headerEvent: Pick<ITrackingEventNewPayload, 'event' | 'eventCategory' | 'eventAction'> = {
  event: 'machinemgtevent',
  eventCategory: 'Machine Management Header',
  eventAction: 'Click Button',
};

const appLauncerFastAccessDescriptions: IAppLauncherFastAccessDescription[] = [
  {
    iconImg: 'assets/icons/app-activities.svg',
    name: 'navbar.app-launcher.fast-access.activities',
    link: environment.farmConnectBaseUrl + 'activities/',
    testId: 'app-fast-access-activities',
    trackEventNew: {
      ...headerEvent,
      eventName: 'Select Quick start',
      customDimensions: { [CustomDimension.EVENT_LABEL]: 'Activities' },
    },
    appendOrgId: true,
    outsideLink: true,
  },
  {
    iconImg: 'assets/icons/app-activities.svg', // TODO: use different icon?
    name: 'navbar.app-launcher.fast-access.activities-import',
    link: environment.farmConnectBaseUrl + 'activities/import',
    testId: 'app-fast-access-import',
    trackEventNew: {
      ...headerEvent,
      eventName: 'Select Quick start',
      customDimensions: { [CustomDimension.EVENT_LABEL]: 'Import' },
    },
    appendOrgId: true,
    outsideLink: true,
  },
  {
    icon: {
      iconName: 'field_000424',
    },
    name: 'navbar.app-launcher.fast-access.fields',
    link: environment.farmConnectBaseUrl + 'fields/',
    testId: 'app-fast-access-fields',
    trackEventNew: {
      ...headerEvent,
      eventName: 'Select Quick start',
      customDimensions: { [CustomDimension.EVENT_LABEL]: 'Fields' },
    },
    appendOrgId: true,
    outsideLink: true,
  },
  {
    iconImg: 'assets/icons/app-maps.svg',
    name: 'navbar.app-launcher.fast-access.maps',
    link: environment.farmConnectBaseUrl + 'maps/',
    testId: 'app-fast-access-maps',
    trackEventNew: {
      ...headerEvent,
      eventName: 'Select Quick start',
      customDimensions: { [CustomDimension.EVENT_LABEL]: 'Maps' },
    },
    appendOrgId: true,
    outsideLink: true,
  },
];

export const appLauncherAppDescriptions: IAppLauncherAppDescription[] = [
  {
    icon: {
      iconName: '',
      iconId: '750146',
    },
    name: 'CLAAS connect –',
    description: 'navbar.app-launcher.connectfarm.description',
    link: environment.farmConnectBaseUrl + 'login/dashboard',
    permission: PLATTFORM_BASE_PERMISSION,
    testId: 'app-connect-farm',
    trackEventNew: { ...headerEvent, eventName: 'Go to Farm Management' },
    appendOrgId: true,
    appLauncerFastAccess: appLauncerFastAccessDescriptions,
    outsideLink: true,
  },
  {
    icon: {
      iconName: '',
      iconId: '778026',
    },
    name: 'CLAAS ID',
    description: 'navbar.app-launcher.claas-id.description',
    link: environment.claasIdDashboardBaseUrl,
    permission: PLATTFORM_ADVANCED_PERMISSION,
    testId: 'app-claas-id',
    trackEventNew: { ...headerEvent, eventName: 'Go to CLAAS ID' },
    newTabLink: true,
    target: '_blank',
  },
];
